'use client';

import React from 'react';

import {useI18n} from '@udemy-v2/i18n';
import {ImageSkeleton, TextSkeleton} from '@udemy-v2/react-reveal-components';

import styles from './categories.module.scss';

const CARD_COUNT = 5;

/**
 * Loading chrome for Categories (Japan-only) — mirrors EnhancedCategoriesComponent's grid
 */
export const CategoriesSkeleton: React.FC = () => {
    const {gettext} = useI18n();

    return (
        <div className={styles.categories} data-purpose="categories-skeleton">
            <span className={`ud-heading-xxl ${styles['section-title']}`}>
                {gettext('Popular categories in Japan')}
            </span>
            <div className={styles['skeleton-cards']} aria-busy="true" aria-hidden="true">
                {Array.from({length: CARD_COUNT}, (_, i) => (
                    <div key={i} className={styles['skeleton-card']}>
                        <TextSkeleton withTitle lineCountPerParagraph={1} />
                        <div className={styles['skeleton-illustration']}>
                            <ImageSkeleton />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
